const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const uuidInText = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export function issueDisplayName(issue, missingName) {
  const name = String(issue?.name || "").trim();
  if (name && !uuidPattern.test(name)) return name;
  const key = String(issue?.internal_key || "").trim();
  return key && !uuidPattern.test(key) ? key : missingName;
}

export function issueDisplayKey(issue) {
  const key = String(issue?.internal_key || "").trim();
  return key && !uuidPattern.test(key) && key !== issueDisplayName(issue, "") ? key : null;
}

export function issueDisplayReason(issue, missingName) {
  return String(issue?.reason || issue?.message || "").replace(
    uuidInText,
    issueDisplayName(issue, missingName)
  );
}
